import { Factory, Zap, Truck, Leaf } from 'lucide-react';

// Scope styling constants
export const SCOPE_COLORS = {
  scope1: 'bg-blue-500',
  scope2: 'bg-cyan-500',
  scope3_amont: 'bg-amber-500',
  scope3_aval: 'bg-indigo-500',
};

export const SCOPE_ICONS = {
  scope1: Factory,
  scope2: Zap,
  scope3_amont: Truck,
  scope3_aval: Leaf,
};
